import ZkButton from './src/button';

/* istanbul ignore next */
ZkButton.install = function(Vue) {
  Vue.component(ZkButton.name, ZkButton);
};

export default ZkButton;



// WEBPACK FOOTER //
// ./src/packages/button/index.js